export default "__VITE_ASSET__7649842d__"